import { IMyArtistsResponse } from '#/types/API/MyArtists';
import { IMyAlbumsResponse } from '#/types/API/myAlbums';
import { IMyPlaylistsResponse } from '#/types/API/myPlaylists';
import withMatcher from '#/utils/withMatcher';
import { TLibrarySelected } from '../reducers/library';

export const createActionLibrarySetAlbums = withMatcher(
  (payload: IMyAlbumsResponse['items']) => {
    return {
      type: 'library/set_albums',
      payload,
    };
  }
);

export const createActionLibraryAddAlbum = withMatcher(
  (payload: IMyAlbumsResponse['items'][number]) => {
    return {
      type: 'library/add_album',
      payload,
    };
  }
);

export const createActionLibraryRemoveAlbum = withMatcher(
  (payload: IMyAlbumsResponse['items'][number]['album']['id']) => {
    return {
      type: 'library/remove_album',
      payload,
    };
  }
);

export const createActionLibraryLoadingAlbums = withMatcher(() => {
  return {
    type: 'library/loading_albums',
  };
});

export const createActionLibraryErrorAlbums = withMatcher(() => {
  return {
    type: 'library/error_albums',
  };
});

export const createActionLibrarySetArtists = withMatcher(
  (payload: IMyArtistsResponse['artists']['items']) => {
    return {
      type: 'library/set_artists',
      payload,
    };
  }
);

export const createActionLibraryAddArtist = withMatcher(
  (payload: IMyArtistsResponse['artists']['items'][number]) => {
    return {
      type: 'library/add_artist',
      payload,
    };
  }
);

export const createActionLibraryRemoveArtist = withMatcher(
  (payload: IMyArtistsResponse['artists']['items'][number]['id']) => {
    return {
      type: 'library/remove_artist',
      payload,
    };
  }
);

export const createActionLibraryLoadingArtists = withMatcher(() => {
  return {
    type: 'library/loading_artists',
  };
});

export const createActionLibraryErrorArtists = withMatcher(() => {
  return {
    type: 'library/error_artists',
  };
});

export const createActionLibrarySetPlaylists = withMatcher(
  (payload: IMyPlaylistsResponse['items']) => {
    return {
      type: 'library/set_playlists',
      payload,
    };
  }
);

export const createActionLibraryAddPlaylist = withMatcher(
  (payload: IMyPlaylistsResponse['items'][number]) => {
    return {
      type: 'library/add_playlist',
      payload,
    };
  }
);

export const createActionLibraryRemovePlaylist = withMatcher(
  (payload: IMyPlaylistsResponse['items'][number]['id']) => {
    return {
      type: 'library/remove_playlist',
      payload,
    };
  }
);

export const createActionLibraryLoadingPlaylists = withMatcher(() => {
  return {
    type: 'library/loading_playlists',
  };
});

export const createActionLibraryErrorPlaylists = withMatcher(() => {
  return {
    type: 'library/error_playlists',
  };
});

export const createActionLibrarySetSelected = withMatcher(
  (payload: TLibrarySelected) => {
    return {
      type: 'library/set_selected',
      payload,
    };
  }
);
